import React, { createContext, useMemo, type ReactNode } from 'react';
import { useRelayEnvironment } from 'react-relay';

import { expValEquals } from '@confluence/feature-experiments';

type PollingScope = {
	pageId: string;
	environment: ReturnType<typeof useRelayEnvironment>;
};

export const AgentSessionPollingContext: React.Context<PollingScope | null> =
	createContext<PollingScope | null>(null);

type Props = { pageId: string; children: ReactNode };

function EnabledPollingProvider({ pageId, children }: Props) {
	const environment = useRelayEnvironment();
	const value = useMemo(() => ({ environment, pageId }), [environment, pageId]);
	return (
		<AgentSessionPollingContext.Provider value={value}>
			{children}
		</AgentSessionPollingContext.Provider>
	);
}

export function AgentSessionPollingProvider({ pageId, children }: Props): React.JSX.Element {
	// Keep the legacy tree and Relay requirements unchanged in control.
	if (!expValEquals('platform_editor_inline_agentic_comments', 'isEnabled', true)) {
		return <>{children}</>;
	}
	return <EnabledPollingProvider pageId={pageId}>{children}</EnabledPollingProvider>;
}
